import { Navigate } from 'react-router-dom';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import PropTypes from 'prop-types';

const ProtectedLayout = ({ children }) => {
    const userId = useBoundStore((state) => state.user.userId);

    return userId ? <>{children}</> : <Navigate to="/login" />;
};

ProtectedLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedLayout;
